import { z } from "zod";
import { ALLOWED_FIELD_KEYS } from "./listing-admin.js";

export const DraftSuggestion = z.object({
  field_key: z.enum(ALLOWED_FIELD_KEYS),
  value: z.unknown(),
  confidence: z.number().min(0).max(1),
  source_evidence: z.object({
    type: z.enum(["photo", "intake_note", "absent"]),
    media_id: z.string().uuid().optional(),
    note_excerpt: z.string().max(500).optional(),
    reasoning: z.string().max(500),
  }),
});
export type DraftSuggestion = z.infer<typeof DraftSuggestion>;

export const DraftOutput = z.object({
  suggestions: z.array(DraftSuggestion).min(0).max(40),
  draft_description: z.record(z.string()).optional(), // {it,en,de}
  photo_alt: z.array(z.object({
    media_id: z.string().uuid(),
    alt: z.record(z.string()),
  })).max(40).optional(),
  missing_required: z.array(z.enum(ALLOWED_FIELD_KEYS)).default([]),
});
export type DraftOutput = z.infer<typeof DraftOutput>;

export const DraftInput = z.object({
  // Worker assembles this — admin endpoint only takes a flag to (re)run.
  force_regenerate: z.boolean().default(false),
});
export type DraftInput = z.infer<typeof DraftInput>;
